import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Styles } from './styles';

export interface ProtoHeaderProps {
  backgroundUri?: string;
  whatsapp?: string;
  /** bottom offset in px (matches CSS bottom on PhoneNumberOverlay) */
  overlayBottom?: number;
  /** right offset in px (matches CSS right on PhoneNumberOverlay) */
  overlayRight?: number;
  /** outline whatsapp container */
  outline?: boolean;
}

/**
 * Fully-parametrized replica of Header.tsx.
 * Renders at the real header dimensions (1200 × 215 px) so it can be
 * scaled down inside ConfigCompanyDataScreen's position picker.
 */
const ProtoHeader: React.FC<ProtoHeaderProps> = ({
  backgroundUri,
  whatsapp,
  overlayBottom = 30,
  overlayRight = 140,
  outline = false
}) => (
  <Styles.HeaderContainer>
    {/* The `style` prop overrides the hardcoded bottom/right from the styled component */}
    <Styles.PhoneNumberOverlay
      outline={outline}
      style={{ bottom: overlayBottom, right: overlayRight }}>
      <WhatsAppIcon sx={{ color: '#04682E', fontSize: '30px' }} />
      <Styles.PhoneNumberText>
        {whatsapp || '(XX) XXXXX-XXXX'}
      </Styles.PhoneNumberText>
      {outline && <Styles.PhoneNumberOverlayAnchorDot />}
      {outline && (
        <Styles.PhoneNumberOverlayCoordinates>
          {`(${overlayBottom}px, ${overlayRight}px)`}
        </Styles.PhoneNumberOverlayCoordinates>
      )}
    </Styles.PhoneNumberOverlay>

    {backgroundUri ? (
      <Styles.BackgroundImage src={backgroundUri} alt="header background" />
    ) : (
      <div
        style={{
          width: '100%',
          height: '100%',
          background: 'linear-gradient(135deg, #e8f0fb 0%, #c5d8f6 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#bbb',
          fontSize: 18
        }}>
        Sem imagem de fundo
      </div>
    )}
  </Styles.HeaderContainer>
);

export default ProtoHeader;
